import React, { useEffect, useState } from 'react';
import './BridalMakeup.css';
import { getEditorialImages } from '../../services/galleryService';

const EditorialMakeup = () => {
  const [images, setImages] = useState([]);
  const [current, setCurrent] = useState(0);
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    getEditorialImages().then(setImages);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [images]);

  const toggleDrawer = () => setDrawerOpen(!drawerOpen);

  return (
    <div className="bridal-page">
      <div className=" slide-up">
        <h1 className="page-title">Editorial Makeup</h1>
      </div>

      <div className="gallery-section">
        {images.length > 0 && <img src={images[current]} alt="main" className="main-image" />}
        <div className="thumbnail-strip">
          {images.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`thumb-${index}`}
              className={`thumbnail ${current === index ? 'active' : ''}`}
              onClick={() => setCurrent(index)}
            />
          ))}
        </div>
      </div>

      <div className="buttons-container">
        <button className="drawer-toggle-btn" onClick={toggleDrawer}>
          All You Need to Know About Editorial Makeup ▾
        </button>
{drawerOpen && (
        <div className="drawer-content">
          <h3>All You Need to Know About Editorial Makeup</h3>
          <p>
            For me, <strong>makeup is more than just a skill — it's my way of expressing creativity.</strong> I’ve always been drawn to <strong>editorial makeup </strong>because it has no rules or boundaries. It gives me the freedom to explore, experiment, and bring bold ideas to life in ways that are completely unique. Whether it's something minimal and striking or wildly imaginative, editorial makeup allows me to turn a vision into something visual, powerful, and unforgettable.
          </p>
          <p>
            Over the years, I've had the opportunity to work across a range of styles — and I specialise in creating <strong> camera-ready looks</strong> that photograph beautifully under studio lights and on high-definition screens. From <strong>Ecommerce shoots to runway shows</strong>, from <strong>fashion campaigns to fantasy-inspired concepts</strong>, I focus on delivering makeup that not only looks flawless, but also tells a story and elevates the entire creative direction.
          </p>
          <p>What I love most is the collaborative process — working closely with photographers, stylists, and models to create something magical together. Every look I create is carefully considered, emotionally driven, and crafted with both <strong>artistry and intention.</strong></p>
          <p>Have something exciting in the works? We'd love to be a part. Get in touch and let’s create something unforgettable together.</p>
        </div>
      )}

        <button className="primary-btn" onClick={() => window.location.href = "/make-an-enquiry"}>
          Make an Enquiry
        </button>

        
      </div>

      
    </div>
  );
};

export default EditorialMakeup;
